
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"256","cy":"256","r":"256","fill":"#F0F0F0"}}),_c('path',{attrs:{"fill":"#D80027","d":"M345.043 256c0 22.261-39.866 77.913-89.043 77.913S166.957 278.261 166.957 256c0-49.178 39.866-89.043 89.043-89.043s89.043 39.865 89.043 89.043z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M345.043 256c0 49.178-39.866 89.043-89.043 89.043S166.957 305.178 166.957 256"}}),_c('path',{attrs:{"d":"M350.441 334.705l23.61-23.611 15.742 15.74-23.61 23.612zM311.085 374.06l23.61-23.612 15.742 15.741-23.61 23.611zM397.67 381.918l23.61-23.611 15.742 15.74-23.61 23.612zM358.313 421.279l23.61-23.611 15.742 15.74-23.61 23.612zM374.054 358.313l23.61-23.611 15.742 15.74-23.61 23.612zM334.709 397.668l23.61-23.612 15.742 15.741-23.61 23.611zM397.678 177.29l-62.962-62.964 15.741-15.74 62.962 62.963zM334.713 161.557l-23.61-23.611 15.74-15.74 23.61 23.612zM374.059 200.908l-23.61-23.611 15.74-15.74 23.61 23.611zM381.915 114.337l-23.61-23.612 15.741-15.74 23.61 23.611zM421.283 153.687l-23.61-23.611 15.741-15.74 23.61 23.61zM90.723 358.317l62.962 62.964-15.742 15.74-62.961-62.963zM153.681 374.05l23.61 23.612-15.74 15.74-23.61-23.612zM114.33 334.703l23.611 23.612-15.74 15.74-23.611-23.611zM137.943 311.09l62.962 62.965-15.741 15.74-62.962-62.964zM153.683 90.719l-62.961 62.964-15.741-15.741 62.961-62.964zM177.286 114.325l-62.962 62.964-15.74-15.74 62.961-62.964zM200.911 137.946L137.95 200.91l-15.74-15.74 62.961-62.964z"}})])
          )
        }
      }
    